import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Instructora de Pilates en Estudio Propio'
}, {
  quote: 'Las clases con progresión real por nivel cambiaron todo. Mis alumnas mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Instructora en Centro de Adultos Mayores'
}, {
  quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Instructora de Pilates Grupal e Individual'
}];
export const TestimonialsPreview = () => {
  return <section className="py-6 md:py-10 bg-white" data-id="element-364">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-365">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-366">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-offwhite p-5 md:p-8 rounded-xl md:rounded-2xl shadow-sm border border-sage-100 flex flex-col h-full" data-id="element-367">
              <div className="flex gap-0.5 mb-2 md:mb-4" data-id="element-368">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-369" />)}
              </div>
              <p className="text-sm md:text-base text-gray-700 italic mb-4 md:mb-6 flex-grow" data-id="element-370">
                "{testimonial.quote}"
              </p>
              <div data-id="element-371">
                <p className="font-bold text-charcoal text-sm" data-id="element-372">
                  {testimonial.name}
                </p>
                <p className="text-xs text-sage font-medium" data-id="element-373">
                  {testimonial.location}
                </p>
                <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-374">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};